const state = () => ({
  items: [],
});

const mutations = {
  ADD_ITEM(state, { product, size, qty = 1 }) {
    const existing = state.items.find(
      (item) =>
        item.productId === product.id &&
        item.size === size
    );

    if (existing) {
      existing.qty += Number(qty);
      return;
    }

    state.items.push({
      productId: product.id,
      size,
      qty: Number(qty),
    });
  },

  REMOVE_ITEM(state, { productId, size }) {
    state.items = state.items.filter(
      (item) =>
        !(
          item.productId === productId &&
          item.size === size
        )
    );
  },

  SET_ITEM_QTY(
    state,
    { productId, size, qty }
  ) {
    const nextQty = Number(qty);

    if (nextQty <= 0) {
      state.items = state.items.filter(
        (item) =>
          !(
            item.productId === productId &&
            item.size === size
          )
      );
      return;
    }

    const item = state.items.find(
      (entry) =>
        entry.productId === productId &&
        entry.size === size
    );

    if (item) {
      item.qty = nextQty;
    }
  },

  CLEAR(state) {
    state.items = [];
  },
};

const actions = {
  addItem({ commit }, payload) {
    commit("ADD_ITEM", payload);
  },

  removeItem({ commit }, payload) {
    commit("REMOVE_ITEM", payload);
  },

  setItemQty({ commit }, payload) {
    commit("SET_ITEM_QTY", payload);
  },

  clear({ commit }) {
    commit("CLEAR");
  },
};

const getters = {
  totalItems(state) {
    return state.items.reduce(
      (sum, item) =>
        sum + Number(item.qty || 0),
      0
    );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
